import React from 'react';
import { Row, Col, Box, Botao, CampoTexto, Alerta, TipoAlerta, TipoBotao, Form } from "@intechprev/componentes-web";
import { UsuarioService } from "../../services";
import { LoginEntidade } from "../../entidades";
import { MasterPage } from "..";
import { reCAPTCHA } from '../../helpers';

interface Props {

}

interface State {
  senhaAntiga: string;
  senhaNova: string;
  confirmarSenha: string;
  mensagemSucesso: boolean
  tipoInputSenhaAntiga: string;
  iconeBotaoSenhaAntiga: string;
  tituloBotaoSenhaAntiga: string;
  tipoInputSenhaNova: string;
  iconeBotaoSenhaNova: string;
  tituloBotaoSenhaNova: string;
  tipoInputSenhaConfirmar: string;
  iconeBotaoSenhaConfirmar: string;
  tituloBotaoSenhaConfirmar: string;
}

export class TrocarSenha extends React.Component<Props, State> {
  private recaptcha = new reCAPTCHA("trocar_senha");

  private page = React.createRef<MasterPage>();
  private form = React.createRef<Form>();
  private alert = React.createRef<Alerta>();

  constructor(props: Props) {
    super(props);

    this.state = {
      senhaAntiga: "",
      senhaNova: "",
      confirmarSenha: "",
      mensagemSucesso: false,
      tipoInputSenhaAntiga: "password",
      iconeBotaoSenhaAntiga: "fas fa-eye",
      tituloBotaoSenhaAntiga: "Mostrar Senha",
      tipoInputSenhaNova: "password",
      iconeBotaoSenhaNova: "fas fa-eye",
      tituloBotaoSenhaNova: "Mostrar Senha",
      tipoInputSenhaConfirmar: "password",
      iconeBotaoSenhaConfirmar: "fas fa-eye",
      tituloBotaoSenhaConfirmar: "Mostrar Senha"
    }
  }

  componentDidMount() {
    // this.page.current.loading(false);
  }

  trocarSenha = async () => {
    // Define os estados iniciais de alertas.
    await this.alert.current.limparErros();
    await this.form.current.validar();

    this.setState({ mensagemSucesso: false })

    // Valida se a nova senha tem 6 ou mais caracteres.
    // if(this.state.senhaNova.length < 6)
    //     this.alert.current.adicionarErro("A nova senha deve possuir no mínimo 6 caracteres.");

    // Valida se os campos de nova senha e confirmação são iguais.
    if (this.state.senhaNova !== this.state.confirmarSenha)
      this.alert.current.adicionarErro("As senhas não coincidem.");

    try {
      if (this.alert.current.state.mensagem.length === 0 && this.alert.current.props.mensagem.length === 0) {

        let le = new LoginEntidade();
        le.SenhaAntiga = this.state.senhaAntiga;
        le.SenhaNova = this.state.senhaNova;


        await UsuarioService.AlterarSenha(le);
        // await UsuarioService.TrocarSenha(this.state.senhaAntiga, this.state.senhaNova);
        this.setState({
          mensagemSucesso: true,
          senhaAntiga: "",
          senhaNova: "",
          confirmarSenha: ""
        });
      }
    } catch (err) {
      if (err.response)
        this.alert.current.adicionarErro(err.response.data)
      else
        console.error(err);
    }

  }

  alternarSenhaVisivelAntiga = () => {
    const senhaVisivel = this.state.tipoInputSenhaAntiga === "password";
    this.setState({
      tipoInputSenhaAntiga: senhaVisivel ? "text" : "password",
      iconeBotaoSenhaAntiga: senhaVisivel ? "fas fa-eye-slash" : "fas fa-eye",
      tituloBotaoSenhaAntiga: senhaVisivel ? "Esconder Senha" : "Mostrar Senha"
    })
  }

  alternarSenhaVisivelNova = () => {
    const senhaVisivel = this.state.tipoInputSenhaNova === "password";
    this.setState({
      tipoInputSenhaNova: senhaVisivel ? "text" : "password",
      iconeBotaoSenhaNova: senhaVisivel ? "fas fa-eye-slash" : "fas fa-eye",
      tituloBotaoSenhaNova: senhaVisivel ? "Esconder Senha" : "Mostrar Senha"
    })
  }

  alternarSenhaVisivelConfirmar = () => {
    const senhaVisivel = this.state.tipoInputSenhaConfirmar === "password";
    this.setState({
      tipoInputSenhaConfirmar: senhaVisivel ? "text" : "password",
      iconeBotaoSenhaConfirmar: senhaVisivel ? "fas fa-eye-slash" : "fas fa-eye",
      tituloBotaoSenhaConfirmar: senhaVisivel ? "Esconder Senha" : "Mostrar Senha"
    })
  }

  render() {
    return (
      <MasterPage {...this.props} ref={this.page}>
        <Row>
          <Col className={"col-lg-12"}>
            <Box titulo={""}>
              <Form ref={this.form}>
                <Alerta mensagem={"A senha deve conter pelo menos 10 caracteres, um número (0-9), uma letra minúscula (a-z), uma letra maiúscula (A-Z)  e um caráter especial (@, #, $, %, *, por exemplo)."} tipo={TipoAlerta.danger} />

                <Row className={"form-group"}>
                  <label htmlFor="senhaAntiga" className="col-2 col-form-label"><b>Senha atual</b></label>
                  <Col tamanho={"10"}>
                    <CampoTexto
                      contexto={this}
                      nome={"senhaAntiga"}
                      obrigatorio
                      tipo={this.state.tipoInputSenhaAntiga}
                      valor={this.state.senhaAntiga}
                      grupo
                      tituloBotao={this.state.tituloBotaoSenhaAntiga}
                      iconeBotao={this.state.iconeBotaoSenhaAntiga}
                      iconeBotaoDireita
                      onBotaoClick={this.alternarSenhaVisivelAntiga}
                    />
                  </Col>
                </Row>

                <Row className={"form-group"}>
                  <label htmlFor="senhaNova" className="col-sm-2  col-form-label"><b>Nova senha</b></label>
                  <Col tamanho={"10"}>
                    <CampoTexto
                      contexto={this}
                      nome={"senhaNova"}
                      obrigatorio
                      tipo={this.state.tipoInputSenhaNova}
                      valor={this.state.senhaNova}
                      grupo
                      tituloBotao={this.state.tituloBotaoSenhaNova}
                      iconeBotao={this.state.iconeBotaoSenhaNova}
                      iconeBotaoDireita
                      onBotaoClick={this.alternarSenhaVisivelNova}
                    />
                  </Col>
                </Row>

                <Row className={"form-group"}>
                  <label htmlFor="confirmarSenha" className="col-sm-2  col-form-label"><b>Confirme nova senha</b></label>
                  <Col tamanho={"10"}>
                    <CampoTexto
                      contexto={this}
                      nome={"confirmarSenha"}
                      obrigatorio
                      tipo={this.state.tipoInputSenhaConfirmar}
                      valor={this.state.confirmarSenha}
                      grupo
                      tituloBotao={this.state.tituloBotaoSenhaConfirmar}
                      iconeBotao={this.state.iconeBotaoSenhaConfirmar}
                      iconeBotaoDireita
                      onBotaoClick={this.alternarSenhaVisivelConfirmar}
                    />
                  </Col>
                </Row>

                {this.state.mensagemSucesso &&
                  <Alerta tipo={TipoAlerta.primary} mensagem={"Senha alterada com sucesso."} />
                }

                <Alerta ref={this.alert} padraoFormulario tipo={TipoAlerta.danger} />
                <hr />

                <Botao submit titulo={"Trocar Senha"} tipo={TipoBotao.primary}
                  onClick={() => this.trocarSenha()} usaLoading />

              </Form>
            </Box>
          </Col>
        </Row>
      </MasterPage>
    );
  }
}
